// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__Rbfgg","col":"Table_col__BWt3j","fulfillmentStatus":"Table_fulfillmentStatus__1FSoz","emailCol":"Table_emailCol__gqM8N"};